import CriteriaDefinitionTable from "../CriteriaDefinitionTable/CriteriaDefinitionTable";
import CriteriaCategoryTable from "../CriteriaCategoryTable/CriteriaCategoryTable";
import "./CriteriaAdminPage.css";

function CriteriaAdminPage() {
    return (
        <>
            <div className="criteria-admin-section">
                <h3>Criteria</h3>
                <CriteriaDefinitionTable />
            </div>
            <div className="criteria-admin-section">
                <h3>Categories</h3>
                <CriteriaCategoryTable />
            </div>
        </>
    );
}

export default CriteriaAdminPage;
